module.exports = __webpack_public_path__ + "static/media/eerikkila-success-story-banner.9770df60.webp";